import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as EmptyReportImage } from 'assets/svgs/report.svg';
import {
  EmptyState as EmptyStateAtom,
  EmptyStateContainer,
} from 'components/atoms/empty-state';

interface Props {
  className?: string;
}
export const ReportEmptyState: FC<Props> = ({ className }) => (
  <EmptyStateContainer className={className}>
    <EmptyStateAtom
      image={<EmptyReportImage />}
      title={
        <FormattedMessage id="timesheets.states.no_timesheet_report.title" />
      }
      message={
        <FormattedMessage id="timesheets.states.no_timesheet_report.description" />
      }
    />
  </EmptyStateContainer>
);
